export default {
  actions: {
    REQUEST_LOADING: 'REQUEST_LOADING',
    REQUEST_LOADED: 'REQUEST_LOADED',
  },
};
